import React from 'react'
import { useForm, UseFormReturn } from 'react-hook-form'

// TODO see if we can leverage a path alias for the base directory or root/src
import TextInput from '../../../../base/TextInput/TextInput'
import { inputProperties } from '../../../../types/inputProperties'
import { validators } from '../../../../utils/validators'
import InputGroup from '../../../../base/InputGroup/InputGroup'

export interface ACHDeliveryMethodProps {
  accountNumber?: inputProperties
  beneficiaryName?: inputProperties
  form?: UseFormReturn
  instructionLabel?: string
  routingNumber?: inputProperties
}

const ACHDeliveryMethod = (props: ACHDeliveryMethodProps) => {
  const useFormDefault = props.form || useForm()
  useFormDefault.setValue('type', 'ACH')

  Object.assign(
    ACHDeliveryMethod.defaultProps.beneficiaryName,
    props.beneficiaryName,
  )
  Object.assign(
    ACHDeliveryMethod.defaultProps.accountNumber,
    props.accountNumber,
  )
  Object.assign(
    ACHDeliveryMethod.defaultProps.routingNumber,
    props.routingNumber,
  )

  return (
    <InputGroup
      inputRows={[
        [
          <TextInput
            form={useFormDefault}
            rules={{ validate: validators.beneficiaryName }}
            {...ACHDeliveryMethod.defaultProps.beneficiaryName}
          />,
        ],
        [
          <TextInput
            form={useFormDefault}
            rules={{ validate: validators.ACHRoutingNumber }}
            {...ACHDeliveryMethod.defaultProps.routingNumber}
          />,
        ],
        [
          <TextInput
            form={useFormDefault}
            rules={{ validate: validators.accountNumber }}
            {...ACHDeliveryMethod.defaultProps.accountNumber}
          />,
        ],
      ]}
    />
  )
}

ACHDeliveryMethod.defaultProps = {
  accountNumber: {
    label: 'Bank Account Number',
    name: 'accountNumber',
    required: true,
  },
  beneficiaryName: {
    label: 'Name on Account',
    name: 'beneficiaryName',
    required: true,
  },
  routingNumber: {
    label: 'ACH Routing Number',
    name: 'routingNumber',
    required: true,
  },
  type: {
    label: 'Delivery Type',
    name: 'type',
    required: true,
  },
  instructionLabel:
    'Transfer to the bank account within 2-3 business days. No Fees.',
}

export default ACHDeliveryMethod
